import {SOAPClient, SOAPClientParameters} from './soapclient';
import {soapResponseToJson} from './xml2json';

export default angular.module('angularSoap', [])

	.factory("$soap", ['$q', function($q) {
		return {
			WSDLUrl: '',
			post: function(url, action, params) {
				var deferred = $q.defer();

				//Create SOAPClientParameters
				var soapParams = new SOAPClientParameters();
				for (var param in params) {
					if (params.hasOwnProperty(param)) {
						soapParams.add(param, params[param]);
					}
				}

				//Create Callback
				var soapCallback = function(e, response) {
					if (e && e.constructor.toString().indexOf("function Error()") != -1) {
						let parsedResponse = soapResponseToJson(response);
						let result = {event: e, message: parsedResponse['Fault']['faultstring']};

						if (angular.isDefined(parsedResponse['Fault']['detail'])) {
							result.message += ' - ' + parsedResponse['Fault']['detail'];
						}

						deferred.reject(result);
					} else {
						deferred.resolve({json: soapResponseToJson(response)[action + 'Response'][action + 'Return']});
					}
				};

				let errCallback = () => {
					deferred.reject({message: 'Server není dostupný'});
				};

				SOAPClient.invoke(url, action, soapParams, true, soapCallback, errCallback);

				return deferred.promise;
			},
			setCredentials: function(token) {
				SOAPClient.token = token;
			},
			setWSDLUrl: (url) => {
				this.WSDLUrl = url;
				SOAPClient.setWSDLUrl(url);
			}
		}
	}]).name;



// WEBPACK FOOTER //
// build/services/soapService/soapService.js